import { render, staticRenderFns } from "./ModalRemanejarServico.vue?vue&type=template&id=0f8f8f8a"
import script from "./ModalRemanejarServico.vue?vue&type=script&lang=js"
export * from "./ModalRemanejarServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports